<shared-ui-inputs-input-group
  [customInput]="phoneTemplate"
  [appendElements]="appendElements"
  [prependElements]="prependElements"
  [tabIndex]="tabIndex"
  [parentFormGroup]="parentFormGroup"
  [display]="display"
  [formName]="formName"
  [name]="name"
>
  <ng-template #phoneTemplate>
    <input pInputText #phoneInput type="tel" [formControl]="control" [tabIndex]="tabIndex" pSize="small" class="w-100" />
    <span *ngIf="!iti?.isValidNumberPrecise() && parentFormGroup.get('phoneNumber')?.dirty" class="invalid-feedback d-block">
      {{ iti?.getNumber() ? 'Invalid phone number.' : 'Phone number is required.' }}
    </span>
  </ng-template>
</shared-ui-inputs-input-group>
